import React, { Fragment } from 'react';
import { Switch, Route } from 'react-router-dom';
import Inde from './components/Index';

import Index from './pages/index';
import Category from './pages/category';
import Orders from './pages/orders';
import Signin from './pages/auth';
import Shop from './pages/shop';
import Sell from './pages/sell';
import Cart from './pages/cart';
import Logout from './components/logout';
import Single from './pages/single';
import UpdateProduct from './pages/updateProduct';

const Routes = () => {
  return (
    <Fragment>
      <Switch>
        <Route path="/index" exact component={Inde} ></Route>
        <Route exact path="/" component={Index}></Route>
        <Route path="/category/:categoryId" component={Category}></Route>
        <Route path="/cart" component={Cart}></Route>
        <Route path="/orders" component={Orders}></Route>
        <Route path="/auth" component={Signin}></Route>
        <Route path="/sell" component={Sell}></Route>
        <Route path="/update/:productId" component={UpdateProduct}></Route>
        <Route path="/shop" component={Shop}></Route>
        <Route path="/single/:productId" component={Single}></Route>
        <Route path="/Logout" component={Logout}></Route>
      </Switch>
    </Fragment>
   );
}

export default Routes;